import { Validator } from './validator';

export class SummaryValidator implements Validator {
    public validate(): boolean {
        return true;
    }
}
